import { Component, OnInit, Input } from '@angular/core';
import { PlantService } from 'src/app/services/plant.service';

@Component({
  standalone: false,
  selector: 'app-bulk-qr-code-download',
  templateUrl: './bulk-qr-code-download.component.html',
  styleUrls: ['./bulk-qr-code-download.component.scss']
})
export class BulkQrCodeDownloadComponent implements OnInit {

  @Input() seletedPlantToDownloadQr: any;

  constructor(
    private plantService: PlantService,
  ) { }

  ngOnInit(): void {
    this.plantService.data$.subscribe(data => {
      this.seletedPlantToDownloadQr = data;
      console.log(this.seletedPlantToDownloadQr);
    });
  }

}
